/** Split component choices while retaining Shopify's native bundle variant selection. */
class LunaBundleOptions extends HTMLElement {
  static observedAttributes = ['data-config'];
  connectedCallback() {
    if (!this.bound) {
      this.addEventListener('click', (event) => this.choose(event));
      this.bound = true;
    }
    this.refresh();
  }
  attributeChangedCallback() { queueMicrotask(() => this.refresh()); }
  refresh() {
    if (!this.isConnected) return;
    const config = JSON.parse(this.dataset.config || '{}');
    if (config.parts?.length !== 2 || config.parts.some(part => part.values.some(value => !value.includes(' — ')))) return;
    this.config = config;
    this.replaceChildren();
    config.parts.forEach((part, index) => {
      const choices = part.values.map(value => ({ value, size: value.split(' — ')[0], color: value.split(' — ').slice(1).join(' — ') }));
      const selected = choices.find(choice => choice.value === part.selected) || choices[0];
      const section = document.createElement('section');
      section.className = 'luna-bundle-part';
      const title = document.createElement('h3');
      title.textContent = part.name;
      section.append(title);
      for (const kind of ['color', 'size']) {
        const label = document.createElement('span');
        label.className = 'luna-bundle-label';
        label.textContent = config[`${kind}Label`];
        const group = document.createElement('div');
        group.className = 'luna-bundle-choices';
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', `${part.name} ${label.textContent}`);
        const applicable = kind === 'size' ? choices.filter(choice => choice.color === selected.color) : choices;
        [...new Set(applicable.map(choice => choice[kind]))].forEach(value => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'luna-bundle-choice';
          button.textContent = value;
          button.dataset.part = index;
          button.dataset.kind = kind;
          button.dataset.value = value;
          button.setAttribute('aria-pressed', String(selected[kind] === value));
          group.append(button);
        });
        section.append(label, group);
      }
      this.append(section);
    });
    this.dataset.ready = '';
  }
  choose(event) {
    const button = event.target.closest('.luna-bundle-choice');
    if (!button || !this.contains(button)) return;
    event.preventDefault();
    const part = this.config.parts[Number(button.dataset.part)];
    const [size, ...colors] = part.selected.split(' — ');
    const color = colors.join(' — ');
    const values = part.values.map(value => ({ value, size: value.split(' — ')[0], color: value.split(' — ').slice(1).join(' — ') }));
    const next = button.dataset.kind === 'size'
      ? values.find(choice => choice.size === button.dataset.value && choice.color === color)
      : values.find(choice => choice.color === button.dataset.value && choice.size === size) || values.find(choice => choice.color === button.dataset.value);
    if (!next || next.value === part.selected) return;
    const picker = this.closest('variant-picker');
    const form = picker?.querySelector('.variant-picker__form');
    if (!form) return;
    const native = [...form.querySelectorAll('[data-option-name]')].find(node => node.dataset.optionName === (part.nativeName || this.nativeNames()[Number(button.dataset.part)]) && node.value.trim() === next.value);
    if (!native) return;
    part.selected = next.value;
    this.dataset.config = JSON.stringify(this.config);
    if (native.tagName === 'OPTION') {
      native.parentElement.value = native.value;
      native.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      native.checked = true;
      native.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  nativeNames() {
    return [...new Set([...this.closest('variant-picker').querySelectorAll('.variant-picker__form [data-option-name]')].map(node => node.dataset.optionName))];
  }
}
if (!customElements.get('luna-bundle-options')) customElements.define('luna-bundle-options', LunaBundleOptions);